@use "../../styling/typography.scss" as *;
@use "../../styling/colors.scss" as *;

.Root {
  @extend %font-family-primary;

  display: grid;
  grid-template-rows: max-content;
  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  border-color: $theme-color-table-border;
  font-size: $font-size-normal;
  line-height: 18px;
  padding: 12px 16px;
  gap: 4px;

  .title {
    display: grid;
    grid-template-columns: min-content auto;
    gap: 4px;
    align-items: center;
    color: $theme-color-text;
    font-weight: $font-weight-bold;

    svg {
      stroke: $theme-form-alert-info-icon;
    }
  }
}
